import { useEffect, useRef } from 'react';

// Close calendar when clicking outside, but allow clicks inside calendar to pass through (for buttons, etc.)
export const useOutsideCalendarClose = ({ calendarRef, isOpen }) => {
  const wasInsideCalendarRef = useRef(false);

  useEffect(() => {
    if (!isOpen) return undefined;
    const trackClickTarget = (event) => {
      const calendarEl = calendarRef.current;
      const target = 'composedPath' in event ? event.composedPath()[0] : event.target;
      wasInsideCalendarRef.current = !!(calendarEl && target && calendarEl.contains(target));
    };
    document.addEventListener('mousedown', trackClickTarget, true);
    document.addEventListener('touchstart', trackClickTarget, true);
    return () => {
      document.removeEventListener('mousedown', trackClickTarget, true);
      document.removeEventListener('touchstart', trackClickTarget, true);
    };
  }, [calendarRef, isOpen]);

  return ({ reason }) => !(reason === 'outsideAction' && wasInsideCalendarRef.current);
};
